module.exports = __webpack_public_path__ + "img/answer_layout_1.da2a1c75.svg";